<template>
  <div class="intro">
    <h2 class="intro-title">{{ title }}</h2>
    <div class="intro-wrapper">
        <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Introduce',
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/style/styleMixins";

.intro {
  &-title {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    .flex_align_center_mixins;
    &::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 20px;
      background: #548EF8;
      margin-right: 12px;
    }
  }
  &-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
</style>
